/**
 * /frontend/src/features/analytics/api/customerAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches customer behavior metrics.
 */
export const getCustomerBehavior = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.CUSTOMERS_BEHAVIOR,
  { storeId, startDate, endDate },
  token,
  'analytics-customers-behavior'
);

/**
 * Fetches customer segment distribution.
 */
export const getCustomerSegments = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.CUSTOMERS_SEGMENTS,
  { storeId, startDate, endDate },
  token,
  'analytics-customers-segments'
);

/**
 * Fetches customer visit trend metrics.
 */
export const getCustomerVisitTrend = async (request, token, storeId, startDate, endDate, granularity) => getJson(
  request,
  ANALYTICS_ENDPOINTS.CUSTOMERS_VISIT_TREND,
  { storeId, startDate, endDate, granularity },
  token,
  'analytics-customers-visit-trend'
);

